// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectPage.test.tsx
import { User, Users } from "@phosphor-icons/react";
import { type ReactNode } from "react";

type AskV2FeedTab = "feed" | "chats";

export function AskV2ProjectTabs({
  active,
  feedLabel,
  chatsLabel,
  viewsLabel,
  onChange,
  variant = "standalone",
  "data-testid": dataTestId = "ask-v2-project-tabs",
}: {
  active: AskV2FeedTab;
  feedLabel: string;
  chatsLabel: string;
  viewsLabel: string;
  onChange: (tab: AskV2FeedTab) => void;
  variant?: "standalone" | "header";
  "data-testid"?: string;
}) {
  const isHeader = variant === "header";

  return (
    <div
      role="tablist"
      aria-label={viewsLabel}
      data-testid={dataTestId}
      className={
        isHeader
          ? "flex shrink-0 items-center gap-4 self-center"
          : "flex shrink-0 gap-8 border-b border-puntt-neutral-gray-5 bg-base-white px-5"
      }
    >
      <TabButton
        label={feedLabel}
        icon={<Users size={16} aria-hidden="true" />}
        data-testid="ask-v2-project-feed-tab"
        active={active === "feed"}
        compact={isHeader}
        onClick={() => onChange("feed")}
      />
      <TabButton
        label={chatsLabel}
        icon={<User size={16} aria-hidden="true" />}
        data-testid="ask-v2-project-chats-tab"
        active={active === "chats"}
        compact={isHeader}
        onClick={() => onChange("chats")}
      />
    </div>
  );
}

function TabButton({
  label,
  icon,
  active,
  compact,
  onClick,
  "data-testid": testId,
}: {
  label: string;
  icon: ReactNode;
  active: boolean;
  compact: boolean;
  onClick: () => void;
  "data-testid": string;
}) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      data-testid={testId}
      data-active={active ? "true" : "false"}
      onClick={onClick}
      className={`flex items-center gap-1.5 border-b-[3px] bg-transparent transition-colors hover:bg-transparent ${
        compact ? "px-0.5 py-0" : "-mb-px px-0.5 py-3"
      } text-[13px] ${
        active
          ? "border-puntt-accent-9 font-semibold text-puntt-accent-9"
          : "border-transparent font-normal text-puntt-neutral-gray-10 hover:text-puntt-neutral-gray-11"
      }`}
    >
      {icon}
      {label}
    </button>
  );
}
